import React from 'react';
import './CollabLinks.css';
import emergent from '../../images/emergent.png';
import blink from '../../images/blink.png';

const links = [
  {
    image: emergent,
    title: 'EMERGENT',
    url: 'https://app.emergent.sh/?via=r2d2tech',
  },
  {
    image: blink,
    title: 'BLINK',
    url: 'https://blink.new/',
  },
];

const CollabLinks = () => (
  <section id="colaboraciones">
    <h2 className="section-heading">colaboraciones</h2>
    <div className="collab-list">
      {links.map((link) => (
        <div key={link.url} className="collab-row">
          <img src={link.image} alt={link.title} className="collab-img" />
          <span className="collab-title">{link.title}</span>
          <a href={link.url} target="_blank" rel="noreferrer" className="btn-cta">
            Ver más
          </a>
        </div>
      ))}
    </div>
  </section>
);

export default CollabLinks;
